<div class="kiosk-shell">
  <div class="device-frame">
    <div class="device-top"></div>

    <div class="device-screen">
      <div class="screen-head">
        <div class="status-widget">
          <div class="status-time">{{ currentTimeLabel }}</div>
          <div class="status-date">{{ currentDateLabel }}</div>
          <div class="status-weather">{{ weatherLabel }}</div>
        </div>
        <div class="estate-name">Albani Estates</div>
      </div>

      @if (screen === 'home') {
        <div class="home-actions">
          <button type="button" class="action-card guest" (click)="openGuest()">
            <fa-icon class="action-icon" [icon]="faUser"></fa-icon>
            <span class="action-label">Guest</span>
          </button>

          <button type="button" class="action-card call" (click)="openCall()">
            <fa-icon class="action-icon" [icon]="faPhone"></fa-icon>
            <span class="action-label">Call</span>
          </button>
        </div>
      }

      @if (screen === 'guest-reservation') {
        <div class="flow-card">
          <h3>Reservation Code</h3>
          <p class="flow-note">Enter your 4-digit reservation code.</p>
          <input
            class="form-control code-input"
            type="password"
            maxlength="4"
            inputmode="numeric"
            pattern="[0-9]*"
            [(ngModel)]="reservationCode"
            (ngModelChange)="reservationCode = sanitizeFourDigits($event)"
            placeholder="----">

          <div class="keypad-grid mt-3">
            <button type="button" class="keypad-key" (click)="pressCodeKey('1')">1</button>
            <button type="button" class="keypad-key" (click)="pressCodeKey('2')">2</button>
            <button type="button" class="keypad-key" (click)="pressCodeKey('3')">3</button>

            <button type="button" class="keypad-key" (click)="pressCodeKey('4')">4</button>
            <button type="button" class="keypad-key" (click)="pressCodeKey('5')">5</button>
            <button type="button" class="keypad-key" (click)="pressCodeKey('6')">6</button>

            <button type="button" class="keypad-key" (click)="pressCodeKey('7')">7</button>
            <button type="button" class="keypad-key" (click)="pressCodeKey('8')">8</button>
            <button type="button" class="keypad-key" (click)="pressCodeKey('9')">9</button>

            <button type="button" class="keypad-key keypad-action" (click)="pressCodeKey('clear')">C</button>
            <button type="button" class="keypad-key" (click)="pressCodeKey('0')">0</button>
            <button type="button" class="keypad-key keypad-action" (click)="pressCodeKey('continue')">&#8594;</button>
          </div>

          @if (codeError) {
            <div class="text-danger mt-2">{{ codeError }}</div>
          }

          <div class="flow-actions mt-3">
            <button class="btn btn-outline-light" type="button" (click)="goHome()">Back</button>
            <button class="btn btn-primary" type="button" (click)="proceedReservationCode()">Continue</button>
          </div>
        </div>
      }

      @if (screen === 'guest-passcode') {
        <div class="flow-card">
          <h3>Passcode</h3>
          <p class="flow-note">Enter your 4-digit passcode.</p>
          <input
            class="form-control code-input"
            type="password"
            maxlength="4"
            inputmode="numeric"
            pattern="[0-9]*"
            [(ngModel)]="passCode"
            (ngModelChange)="passCode = sanitizeFourDigits($event)"
            placeholder="----">

          <div class="keypad-grid mt-3">
            <button type="button" class="keypad-key" (click)="pressCodeKey('1')">1</button>
            <button type="button" class="keypad-key" (click)="pressCodeKey('2')">2</button>
            <button type="button" class="keypad-key" (click)="pressCodeKey('3')">3</button>

            <button type="button" class="keypad-key" (click)="pressCodeKey('4')">4</button>
            <button type="button" class="keypad-key" (click)="pressCodeKey('5')">5</button>
            <button type="button" class="keypad-key" (click)="pressCodeKey('6')">6</button>

            <button type="button" class="keypad-key" (click)="pressCodeKey('7')">7</button>
            <button type="button" class="keypad-key" (click)="pressCodeKey('8')">8</button>
            <button type="button" class="keypad-key" (click)="pressCodeKey('9')">9</button>

            <button type="button" class="keypad-key keypad-action" (click)="pressCodeKey('clear')">C</button>
            <button type="button" class="keypad-key" (click)="pressCodeKey('0')">0</button>
            <button type="button" class="keypad-key keypad-action" (click)="pressCodeKey('continue')">&#8594;</button>
          </div>

          @if (codeError) {
            <div class="text-danger mt-2">{{ codeError }}</div>
          }

          <div class="flow-actions mt-3">
            <button class="btn btn-outline-light" type="button" (click)="goHome()">Back</button>
            <button class="btn btn-success" type="button" [disabled]="passCode.length !== 4" (click)="proceedPassCode()">Open Gate</button>
          </div>
        </div>
      }

      @if (screen === 'guest-confirming' && !showSuccessModal) {
        <div class="flow-card confirming-card">
          <div class="confirm-spinner" aria-hidden="true"></div>
          <h3 class="mt-3">Confirming Code Details</h3>
          <p class="flow-note mb-0">Please wait while we verify your reservation and passcode.</p>
        </div>
      }

      @if (screen === 'guest-confirming' && showSuccessModal) {
        <div class="success-overlay">
          <div class="success-modal">
            <fa-icon class="success-icon" [icon]="faCheckCircle"></fa-icon>
            <h4>Gate opened successfully.</h4>
            <p class="mb-0">Success</p>
          </div>
        </div>
      }

      @if (screen === 'apartment-select') {
        <div class="apartment-layout">
          <div class="search-home-row">
            <input
              type="text"
              class="form-control search-input"
              inputmode="numeric"
              [(ngModel)]="searchText"
              placeholder="Search apartment number">
            <button class="btn btn-outline-light home-btn" type="button" (click)="goHome()">
              <fa-icon [icon]="faHome"></fa-icon>
              <span>Home</span>
            </button>
          </div>

          <div class="tiles-grid">
            @for (apartment of filteredApartments; track apartment) {
              <button class="tile-btn" type="button" (click)="chooseApartment(apartment)">
                {{ apartment }}
              </button>
            }
          </div>
        </div>
      }

      @if (screen === 'call-screen') {
        <div class="flow-card call-card">
          <h2>Albani Estates</h2>
          <p class="apartment-value">Apartment {{ selectedApartment }}</p>

          <div class="flow-actions call-actions mt-3">
            <button class="btn btn-primary" type="button" (click)="callOrNotify()">
              <fa-icon class="me-2" [icon]="faBell"></fa-icon>
              Call/Notify
            </button>
            <button class="btn btn-outline-danger" type="button" (click)="cancelCall()">
              <fa-icon class="me-2" [icon]="faTimes"></fa-icon>
              Cancel
            </button>
          </div>

          @if (callMessage) {
            <div class="alert alert-success mt-3 mb-0">{{ callMessage }}</div>
          }
        </div>
      }
    </div>

    <div class="device-bottom"></div>
  </div>
</div>
